// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as ClickToPayHelpers$OrcaPaymentPage from "../Types/ClickToPayHelpers.bs.js";

function ClickToPayUiComponents$LoadingState(props) {
  return React.createElement((function (prim) {
                return React.createElement("src-loader", prim);
              }), {});
}

var LoadingState = {
  make: ClickToPayUiComponents$LoadingState
};

function ClickToPayUiComponents$OtpInput(props) {
  var setIsClickToPayRememberMe = props.setIsClickToPayRememberMe;
  var getCards = props.getCards;
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var match = React.useState(function () {
        return false;
      });
  var setIsOtpSubmitting = match[1];
  var match$1 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.clickToPayConfig);
  var setClickToPayConfig = match$1[1];
  var clickToPayConfig = match$1[0];
  var otpValueRef = React.useRef("");
  var match$2 = React.useState(function () {
        return false;
      });
  var setResendLoading = match$2[1];
  var callBacks_otpChanged = function (ev) {
    setClickToPayConfig(function (prev) {
          var newrecord = Caml_obj.obj_dup(prev);
          newrecord.otpError = "";
          return newrecord;
        });
    Core__Option.forEach((ev == null) ? undefined : Caml_option.some(ev), (function (value) {
            var otp = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(value), "detail", "");
            if (otp.length === 6) {
              otpValueRef.current = otp;
              return ;
            }
            
          }));
  };
  var callBacks_continueClicked = function (param) {
    var verifyUserAndGetCards = async function () {
      try {
        setIsOtpSubmitting(function (param) {
              return true;
            });
        await getCards(otpValueRef.current);
        return setIsOtpSubmitting(function (param) {
                    return false;
                  });
      }
      catch (raw_err){
        var err = Caml_js_exceptions.internalToOCamlException(raw_err);
        return loggerState.setLogError(Core__Option.getOr(JSON.stringify({
                            message: "User validation failed - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err)),
                            scheme: "VISA"
                          }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
      }
    };
    verifyUserAndGetCards();
  };
  var callBacks_resendClicked = function (param) {
    setClickToPayConfig(function (prev) {
          var newrecord = Caml_obj.obj_dup(prev);
          newrecord.otpError = "";
          return newrecord;
        });
    var resendOtp = async function () {
      try {
        setResendLoading(function (param) {
              return true;
            });
        await getCards("");
        return setResendLoading(function (param) {
                    return false;
                  });
      }
      catch (raw_err){
        var err = Caml_js_exceptions.internalToOCamlException(raw_err);
        return loggerState.setLogError(Core__Option.getOr(JSON.stringify({
                            message: "resend otp failed - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err)),
                            scheme: "VISA"
                          }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
      }
    };
    resendOtp();
  };
  var callBacks_rememberMe = function (ev) {
    Core__Option.forEach((ev == null) ? undefined : Caml_option.some(ev), (function (e) {
            var dict = Utils$OrcaPaymentPage.getDictFromJson(e);
            var rememberMe = Utils$OrcaPaymentPage.getBool(Utils$OrcaPaymentPage.getDictFromDict(dict, "detail"), "rememberMe", false);
            setIsClickToPayRememberMe(function (param) {
                  return rememberMe;
                });
          }));
  };
  React.useEffect((function () {
          var srcOtpInput = document.querySelector("src-otp-input");
          var controller = new AbortController();
          var signal = controller.signal;
          var listeners = [
            {
              name: "otpChanged",
              callback: callBacks_otpChanged
            },
            {
              name: "continue",
              callback: callBacks_continueClicked
            },
            {
              name: "resendOtp",
              callback: callBacks_resendClicked
            },
            {
              name: "rememberMe",
              callback: callBacks_rememberMe
            }
          ];
          Core__Option.forEach((srcOtpInput == null) ? undefined : Caml_option.some(srcOtpInput), (function (element) {
                  listeners.forEach(function (listener) {
                        var $$event = listener.name;
                        var callback = listener.callback;
                        var options = {
                          signal: signal
                        };
                        Core__Option.forEach(element.addEventListener, (function (func) {
                                func($$event, callback, options);
                              }));
                      });
                }));
          return (function () {
                    controller.abort();
                  });
        }), []);
  return React.createElement(ClickToPayHelpers$OrcaPaymentPage.SrcOtpInput.make, {
              "display-header": false,
              "display-cancel-option": false,
              "display-remember-me": true,
              "disable-elements": match[0],
              "is-successful": false,
              "otp-resend-loading": match$2[0],
              "error-reason": clickToPayConfig.otpError,
              locale: "en-US",
              id: "src-otp-input",
              type: "",
              "card-brands": "",
              "masked-identity-value": clickToPayConfig.maskedIdentity,
              "network-id": " ",
              "auto-submit": false
            });
}

var OtpInput = {
  make: ClickToPayUiComponents$OtpInput
};

export {
  LoadingState ,
  OtpInput ,
}
/* react Not a pure module */
